import { isAuthenticated, setAuthenticated } from 'app/storage/auth';

const initialState = {
    isAuthenticated: isAuthenticated(),
    account: null,
    loading: false,
    loadingByToken: false,
    error: null,
};

const loginReducer = (state, action) => {
    switch (action.type) {
        case 'LOGIN_PENDING': {
            return {
                ...state,
                loading: true,
            };
        }
        case 'LOGIN_TOKEN_PENDING': {
            return {
                ...state,
                loadingByToken: true,
            };
        }
        case 'LOGIN_REJECTED': {
            setAuthenticated(null);
            return {
                ...state,
                error: action.payload,
                loading: false,
                loadingByToken: false,
                account: null,
                isAuthenticated: false,
            };
        }
        case 'LOGIN_FULFILLED': {
            const { account, token } = action.payload;
            setAuthenticated(token);
            return {
                ...state,
                error: null,
                loading: false,
                loadingByToken: false,
                account,
                isAuthenticated: true,
            };
        }
        case 'LOGIN_TOKEN_FULFILLED': {
            const account = action.payload;
            return {
                ...state,
                error: null,
                loading: false,
                loadingByToken: false,
                account,
                isAuthenticated: true,
            };
        }
        default:
            return state;
    }
};

const logoutReducer = (state, action) => {
    switch (action.type) {
        case 'LOGOUT_PENDING': {
            return {
                ...state,
                fetching: true,
                fetched: false,
            };
        }
        case 'LOGOUT_REJECTED': {
            return {
                ...state,
                fetching: false,
                error: action.payload,
                fetched: true,
            };
        }
        case 'LOGOUT_FULFILLED': {
            setAuthenticated(null);
            return {
                ...state,
                fetching: false,
                account: null,
                isAuthenticated: false,
                fetched: true,
            };
        }
        default:
            return state;
    }
};

const reducer = (state = initialState, action) => {
    const { type } = action;
    if (type.startsWith('LOGIN')) {
        return loginReducer(state, action);
    } else if (type.startsWith('LOGOUT')) {
        return logoutReducer(state, action);
    } else {
        return state;
    }
};

export default reducer;
